/*
 *   Copyright (c) 2025 LoginID Inc
 *   All rights reserved.

 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at

 *   http://www.apache.org/licenses/LICENSE-2.0

 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

import { Button, Grid, Text, Divider, Image, Container, Flex, PinInput, Space, Stack, Stepper, Title, StepperProps, GridCol } from "@mantine/core";
import {
  IconCreditCard,
  IconFaceId,
  IconFingerprint,
} from "@tabler/icons-react";
import { LIDService } from "@/services/loginid";
import ParseUtil from "@/lib/parse";
import { CheckoutRequest } from ".";
import { useEffect, useState } from "react";
import { AddPasskey } from "@/components/common/AddPasskey";
import { SignupViewEnum } from "./CheckoutLoginOTP";
import { TimerUtils } from "@/lib/timer";

export interface TxPayload {
  Merchant: string;
  Subtotal: string;
  Shipping: string;
  Tax: string;
  Total: string;
  At: Date;
  Address: Address;
  Contact: string;
  Email: string;
  Note: string;
}

export interface Address {
  Street: string;
  City: string;
  State: string;
  Country: string;
  Postal: string;
}

export interface CheckoutAgentProgressProps {
  username: string;
  token: string;
  request: CheckoutRequest;
  onComplete: () => void;
}


export enum AgentViewEnum {
  CART = "cart",
  FILL = "fill",
  CONFIRM = "confirm",
}
export function CheckoutAgentProgress(props: CheckoutAgentProgressProps) {

  useEffect(() => {
    startAgent();


  }, []);

  async function startAgent() {
    // step 1:
    await TimerUtils.sleep(5000);
    setActive(1);
    await TimerUtils.sleep(5000);
    setActive(2);
    await TimerUtils.sleep(5000);
    props.onComplete();
    // step 2:
    // step 3:
  }

  const [view, setView] = useState<AgentViewEnum>(AgentViewEnum.CART);
  const [active, setActive] = useState(0);

  const stepTitle = [`Adding Items to Cart`, `Entering Payment and Shipping`, `Placing Your Order`]
  const stepDescription = [
    `Your agent is currently adding your items into cart for checkout at ${props.request.merchant}.`,
    `Your agent is filling your payment, contact, and shipping at checkout`,
    `Your agent is completing your order at ${props.request.merchant}`
  ]

  const stepImage = [
    `/assets/checkout/checkout-headset-cart.png`,
    `/assets/checkout/checkout-headset-fill.png`,
    `/assets/checkout/checkout-headset-confirm.png`,
  ]

  function handleCartNext() {

  }

  return (
    <>
        <Container w="100%">
      <Stack justify="space-between" style={{ minHeight: "80vh" }} ml="xl" mr="xl" >
        <StyledStepper active={active} onStepClick={setActive}>
          <Stepper.Step label="Step 1" description="Add Items" loading={active==0?true:false}/>
          <Stepper.Step label="Step 2" description="Fill payment" loading={active==1?true:false} />
          <Stepper.Step label="Step 3" description="Complete order" loading={active==2?true:false}/>
        </StyledStepper>
        <Grid>
          <Grid.Col span={4} ta="left"><Text size="sm" c="dimmed">Add Items</Text></Grid.Col>
          <Grid.Col span={4}><Text size="sm" c="dimmed">Fill payment</Text></Grid.Col>
          <Grid.Col span={4} ta="right"><Text size="sm" c="dimmed">Complete order</Text></Grid.Col>
        </Grid>
          <Flex align="center"  direction="column" ml="xl" mr="xl" style={{ flex: 1 }}>
            <Title order={4} mt="md" mb="sm">
              {stepTitle[active]}
            </Title>

            <Text size="sm">{stepDescription[active]}</Text>
            <Space h="md"></Space>


            <Image
              h={200}
              w={300}
              src={stepImage[active]}
              mb="md"
            />

          </Flex>
        <Stack justify="center" align="center" style={{ height: "200", width: "100%" }}>
          <Text size="sm">Agent is powered by <b>LoginID Inc.</b></Text>
          {/*<Text fw={700} size="sm">Privacy Notice | Service Agreement | Opt out</Text>*/}
        </Stack>
      </Stack>
        </Container>

    </>
  );
}


interface AgentNextProps {
  onComplete: () => void;
}


function StyledStepper(props: StepperProps) {
  return (
    <Stepper
      styles={{
        stepBody: {
          display: 'none',
        },
        step: {
          padding: 0,
        },

        stepIcon: {
          borderWidth: 4,
        },

        separator: {
          marginLeft: 16,
          marginRight: 16,
          height: 10,
        },
      }}
      size="xs"
      {...props}
    />
  );
}